/**
 * Модуль для загрузки и отображения магазина существ
 */

import { logger } from "../../utils/logger.js";

/**
 * Создаёт загрузчик экрана магазина
 */
export function createStoreScreenLoader({
  safeFetch,
  getApiUrl,
  renderCreatureCard,
  documentRef = document,
}) {
  /**
   * Загружает и отображает список существ в магазине
   */
  async function loadStoreScreen() {
    const domCache = window.__domCacheManager;
    const loadingManager = window.__loadingIndicatorManager;
    
    const container = domCache?.getCachedElement("#store-items", documentRef) 
      || documentRef.getElementById("store-items");
    
    if (!container) {
      logger.error("Store items container not found");
      return;
    }

    // Показываем skeleton loader
    if (loadingManager) {
      loadingManager.showLoading("store-load", {
        target: container,
        type: "skeleton"
      });
    } else {
      const loadingHTML = '<div class="loading">Загрузка...</div>';
      domCache?.updateHTML("#store-items", loadingHTML, documentRef) ||
      (container.innerHTML = loadingHTML);
    }

    try {
      const apiUrl = getApiUrl();
      const response = await safeFetch(`${apiUrl}/creatures/store`, {
        showLoading: false // Управляем загрузкой вручную
      });

      if (response.success && response.data.success) {
        // Очищаем контейнер
        container.innerHTML = "";
        
        // Используем DocumentFragment для батчинга
        const fragment = documentRef.createDocumentFragment();
        const items = response.data.items || [];
        items.forEach((item) => {
          const card = renderCreatureCard(item, true);
          if (card) {
            fragment.appendChild(card);
          }
        });
        container.appendChild(fragment);
      } else {
        const errorHTML = '<div class="error">Ошибка загрузки магазина</div>';
        domCache?.updateHTML("#store-items", errorHTML, documentRef) ||
        (container.innerHTML = errorHTML);
      }
    } catch (error) {
      logger.error("Load store error:", error);
      const errorHTML = '<div class="error">Ошибка загрузки магазина</div>';
      domCache?.updateHTML("#store-items", errorHTML, documentRef) ||
      (container.innerHTML = errorHTML);
    } finally {
      // Скрываем skeleton loader
      if (loadingManager) {
        loadingManager.hideLoading("store-load");
      }
    }
  }

  return {
    loadStoreScreen,
  };
}















